<template>

<div class="app-container">
      <el-container class="app-demo">
           <el-header>
            <el-menu
            
              class="el-menu"
              mode="horizontal"
              :ellipsis="false"
              @select="handleSelect"
            >

     <el-menu-item  index="home">Obsidian markmind docs</el-menu-item>

      <div class="flex-grow" />
      <el-menu-item index="home/price">price</el-menu-item>
      <el-menu-item index="home/website">website</el-menu-item>
      <el-menu-item index="home/github">github</el-menu-item>
  </el-menu>

 </el-header>
           <el-container>
            <el-aside width="360px">
                 <el-menu
       
     
        class="el-menu-vertical-demo"
         :default-active="activeIndex"
        @select="handleSelect"
       
        
      >
        <el-sub-menu index="1">
          <template #title>
          <el-icon><Document /></el-icon>
            <span>Mindmap</span>
          </template>
          <el-menu-item-group title="Basic mode">
            <el-menu-item index="basic">Create basic mode mindmap</el-menu-item>
            <el-menu-item index="basic/outline">Display basic mode to outline</el-menu-item>
            <el-menu-item index="basic/table">Display basic mode to table</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group title="Rich mode">
            <el-menu-item index="rich">Create rich mode mindmap</el-menu-item>
            <el-menu-item index="rich/markdown">Get markdown text from mindmap</el-menu-item>
            <el-menu-item index="rich/copy">Copy&paste node of mindmap</el-menu-item>
            <el-menu-item index="rich/embed">Embed mindmap in other mds</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group title="Shortcut">
            <el-menu-item index="rich/shortcut">Shortcut</el-menu-item>
            <el-menu-item index="rich/common">Common operations</el-menu-item>
          </el-menu-item-group>
        </el-sub-menu>

        <el-sub-menu index="2">
           <template #title>
            <el-icon><Sunny /></el-icon>
            <span>PDF annotator</span>
          </template>
          
            <el-menu-item index="pdfAnnotator">Features</el-menu-item>
            <el-menu-item index="pdf/highlight">Extracting annotations from pdf files</el-menu-item>
            <el-menu-item index="pdf/commitHighlight">Committing highlights and notes to pdf</el-menu-item>
            <el-menu-item index="pdf/relate">Relate node with annotation</el-menu-item>
          
        </el-sub-menu>
        <!-- <el-menu-item index="3" disabled>
          <el-icon><document /></el-icon>
          <span>Navigator Three</span>
        </el-menu-item>
        <el-menu-item index="4">
          <el-icon><setting /></el-icon>
          <span>Navigator Four</span>
        </el-menu-item> -->
      </el-menu>



            </el-aside>
              <el-container class="markdown-body">
                <router-view></router-view>
              </el-container>
          </el-container>
        </el-container>
</div>

  <Index />
</template>

<script  setup>

import { ref } from 'vue'
import {  useRouter } from 'vue-router'


const router = useRouter()

const activeIndex = ref('1');
const handleSelect = (key) => {
  if(key=='home'){
     router.push('/');
  }
  if(key=='home/github'){
     window.open('https://github.com/MarkMindCkm/obsidian-markmind')
  }

  if(key=='home/website'){
     window.open('https://www.markmind.net')
  }

  if(key=='home/price'){
     router.push(key);
  }
 
  if(key.startsWith('basic')||key.startsWith('rich')||key.startsWith('pdf')){
      router.push(key);
  }
  
}




</script>

<style>

html,body{
  margin: 0;
  padding: 0;
  height: 100%;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  color: #2c3e50;
}

.flex-grow {
  flex-grow: 1;
}

.el-menu.el-menu--horizontal{
  display: flex;
}

.markdown-body i{
   color: #196ff1;
   font-size: 0.8em;
}

.el-menu {
  border-right: 0!important;
}
.el-aside {
   border-right: solid 1px var(--el-menu-border-color);;
}
.app-container,.app-demo{
  height: 100%;
}

</style>
